import { FC, ReactElement } from "react";
import { BoxProps, SvgIconProps, TypographyProps } from "@mui/material";

import { Content, Icon, Text, Wrapper } from "./styled";

export interface IEmptyPlaceholder {
  icon: ReactElement;
  text: string;
  svgIconProps?: SvgIconProps;
  textProps?: TypographyProps;
  wrapperProps?: BoxProps;
}

export const EmptyPlaceholder: FC<IEmptyPlaceholder> = props => {
  const { icon, text, textProps, svgIconProps, wrapperProps } = props;

  return (
    <Wrapper {...wrapperProps}>
      <Content>
        <Icon {...svgIconProps}>{icon}</Icon>
        <Text {...textProps}>{text}</Text>
      </Content>
    </Wrapper>
  );
};
